import * as api from "./apiUtils";
const baseUrl = api.apiUrl + "diet";

export async function getUserDiets(userId) {
    return api.getAsync(`${baseUrl}/getUserDiets`, userId);
}

export async function getDiet(dietId) {
    return api.getAsync(baseUrl, dietId);
}

export async function deleteDiet(dietId) {
    return api.deleteAsync(baseUrl, dietId);
}

export async function generateDiet(dietPars) {
    try {
        let result = await fetch(`${baseUrl}/generate`, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(dietPars)
        });
        return api.handleResponse(result);
    } catch (error) {
        api.handleError(error);
    }
}

export async function addDiet(diet) {
    return api.postAsync(baseUrl, diet);
}

export async function updateDiet(dietId, diet) {
    return api.putAsync(baseUrl, dietId, diet);
}

export async function makeFavorite(dietId, isFavorite) {
    return api.putAsync(`${baseUrl}/makeFavorite`, dietId, isFavorite);
}

export async function getAlternatives(food, userId) {
    try {
        let result = await fetch(`${baseUrl}/getAlternatives?userid=${userId}`, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(food)
        });
        return api.handleResponse(result);
    } catch (error) {
        api.handleError(error);
    }
}
